export default __webpack_public_path__ + "static/media/logo_cfi_grey_p.3458a0c2.svg";